<template>
  <div>
    <transfers :write-off="true"/>
  </div>     
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue"
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import useCommonMixin from '@/components/commonMixin.js'
import Transfers from "./Transfers.vue";

export default {
  name: 'WriteOffs',
  components: { Transfers },

  setup(props){
    useCommonMixin()
    const { jwtAccessValid, asyncForEach, isReciever, userProfile, isAdmin, isManager, isMobile } = useCommonMixin()
    const store = useStore()
    const router = useRouter()
    const docs = ref([])
    const profiles = ref([{}])

    return {
      jwtAccessValid,
      isReciever,
      docs,
      profiles,
      router,
      userProfile,
      isAdmin,
      isManager,
      isMobile,
    }
  }


}

</script>

<style>
.canceled {
   background-color: #e44d4d6b !important;
}
</style>

